import {State} from '@ispm-client/modules/bpmn-modeler/store/state';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectBpmnModelerState} from './bpmn-modeler-state.selector';
import {
  NodeConfigurationResult,
  NodeConfigurationPanelActionTypes
} from "@ispm-client/modules/bpmn-modeler/store/actions";
import {isEqual} from 'lodash'

const isDataChanged = (nodeData): boolean => {
  let initData: NodeConfigurationResult,
      newData:  NodeConfigurationResult;

  if (nodeData) {
    initData = nodeData.get(NodeConfigurationPanelActionTypes.INITIAL_DATA);
    newData = nodeData.get(NodeConfigurationPanelActionTypes.UPDATED_DATA);
  }

  return initData && newData ? !isEqual(initData, newData) : false;
};

export const selectNodeData: MemoizedSelector<object, Map<string, NodeConfigurationResult>> =
  createSelector(selectBpmnModelerState, (state: State) => state.nodeConfigurationPanelState);

export const selectIsNodeDataChanged: MemoizedSelector<object, boolean> =
  createSelector(selectNodeData, isDataChanged);
